import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ProductService } from '@app/api/api';
import { Subscription, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { UtilService } from '@app/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '@app/core/_base/layout';
import { select, Store } from '@ngrx/store';
import { User } from '@app/model/user';
import { AppState } from '@app/core/reducers';

import { Observable } from 'rxjs';
import { currentUser, isLoggedIn } from '@app/core/auth';
@Component({
  selector: 'meu-app-home-page-discount',
  templateUrl: './app-home-page-discount.component.html',
  styleUrls: ['./app-home-page-discount.component.scss'],
})
export class AppHomePageDiscountComponent implements OnInit, OnDestroy {
  hotDealProduct: any = [];
  hotDealProduct$ = new Subject();
  private subscriptions: Subscription[] = [];
  host = environment.backendhost;
  user$: Observable<User>;
  constructor(
    private productService: ProductService,
    public translate: TranslateService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService
  ) {}

  showLoadMore = true;
  pageSize: number = 6;
  pageIndex: number = 1;
  showPrice: boolean = false;
  ngOnInit() {
    this.getHotDeal();
    this.subscriptions.push(
      this.translationService.language$.subscribe(() => {
        this.getHotDeal();
      })
    );
    // isLoggedIn — có giá trị ngay khi Login action dispatch
    this.store.pipe(select(isLoggedIn)).subscribe(loggedIn => {
      if (loggedIn) {
        this.showPrice = true;
      } else {
        const token = localStorage.getItem(environment.authTokenKey);
        this.showPrice = !!(token && token.length > 10);
      }
      this.cdr.detectChanges();
    });

    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((res) => {
      if (res) {
        this.showPrice = true;
        this.cdr.detectChanges();
      }
    });
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  getHotDeal() {
    this.subscriptions.push(
      this.productService
        .apiProductsDiscountGet('is_hidden==false', '', this.pageIndex, this.pageSize)
        .subscribe((res) => {
          this.hotDealProduct = res.data.collection;
          const currentLang = this.translationService.getSelectedLanguage();
          this.hotDealProduct.forEach((item) => {
            item.sale_off = Math.round(100 - (item.price / item.origin_price) * 100);
            item.seo_name = UtilService.slugify(item.name);
            if (currentLang === 'en' && item.extend_product_en && item.extend_product_en.name) {
              item.name = item.extend_product_en.name;
            } else if (currentLang === 'ch' && item.extend_product_zh && item.extend_product_zh.name) {
              item.name = item.extend_product_zh.name;
            }
          });
          this.hotDealProduct$.next(res.data.collection);
          if (this.pageSize >= res.data.total) {
            this.showLoadMore = false;
          }
        })
    );
  }

  loadMore() {
    this.pageSize += 10;
    this.getHotDeal();
  }

  getPrice(price: any): string {
    return price || this.translate.instant('ECOMMERCE.PRODUCT.CONTACT');
  }

  getQuantityText(quantity: number): string {
    if (quantity > 0) {
      return this.translate.instant('ECOMMERCE.PRODUCT.AVAILABLE') + ': ' + quantity;
    }
    return this.translate.instant('ECOMMERCE.PRODUCT.OUT_OF_STOCK');
  }

  getWarehouse(name: string): string {
    return name || this.translate.instant('ECOMMERCE.PRODUCT.NOT_UPDATED');
  }
}
